import { useSelector } from 'react-redux';
import { RootState } from '@nxsys/store';

const EMPLOYEES_LIST_PERMISSION = 'COMPANY.EMPLOYEES.LIST';

/**
 * The dashboard "Action Required" popups drill down into employee/subcontractor
 * records (name, email, NI/PPS number, recurring payments…), so opening them is
 * gated on the same permission as the Employees module. A user who can only view
 * the dashboard (has COMPANY.DASHBOARD.LIST but not COMPANY.EMPLOYEES.LIST) sees
 * the alert counts but cannot open the list popup — mirroring the menu/route
 * visibility enforced for the Employees page in NX-5440.
 */
export const useCanAccessEmployees = (): boolean => {
  const permissions = useSelector(
    (state: RootState) => state.appStore.permissions,
  );
  return permissions?.includes(EMPLOYEES_LIST_PERMISSION) ?? false;
};
